module.exports = __webpack_public_path__ + "img/375_banner_4.1daf260b.jpg";